module.exports = __webpack_public_path__ + "img/coupon-4.7cf478f6.png";